
import {kindlmann} from "./kindlmann.js";
import {buildScale} from "./palette.js";

export function createDuexttauPalette() {

    const bounds = [0.0001, 3.0000];  // units: τ
    return buildScale(bounds, kindlmann, Math.log, Math.exp);

}
